module.exports = __webpack_public_path__ + "static/img/echo.6e3ef60c.png";